import { gql } from '@apollo/client'

export const LabelFragment = gql`
  fragment LabelFragment on Label {
    id
    createdAt
    updatedAt
    name
  }
`
